module.exports = __webpack_public_path__ + "img/104.db5f41fd.jpg";